import React from "react";

const CEL_ORBIT = "M24,16 a8,8 0 0 1 0,16 a4,4 0 0 1 0,-8 a4,4 0 0 0 0,-8 Z";

export const CelestioMark = ({ size = 26 }) => (
  <svg className="brand-mark-glyph" viewBox="0 0 48 48" height={size} width={size} role="img" aria-label="Celestio">
    <g fill="var(--logo-1, #17151F)">
      <circle cx="24" cy="13" r="11.5" />
      <circle cx="13" cy="24" r="11.5" />
      <circle cx="35" cy="24" r="11.5" />
      <circle cx="24" cy="35" r="11.5" />
    </g>
    <path d={CEL_ORBIT} fill="var(--logo-2, #B399FF)" />
    <path d={CEL_ORBIT} transform="rotate(180 24 24)" style={{ fill: "var(--logo-bg, #FFFFFF)" }} />
  </svg>
);

// Celestio lockup. variant="light" for dark backgrounds.
const CelestioLogo = ({ size = 26, variant = "light", large = false }) => (
  <span className={"brand-lock" + (large ? " brand-lock--large" : "") + (variant === "light" ? " brand-lock--light" : "")}>
    <CelestioMark size={size} />
    <span className="brand-word">Celestio</span>
  </span>
);

export default CelestioLogo;
